import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { IndexComponent } from './index/index.component';
import {myProfileRouting} from "./my-profile.routing";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [
    IndexComponent
  ],
  imports: [
    CommonModule,
    myProfileRouting,
    NgbModule,
    FormsModule
  ]
})
export class MyProfileModule { }
